/**
 * Custom JWD Grid - Video Autoplay & Animations
 */
document.addEventListener('DOMContentLoaded', function() {

  // Keep grid media poster-only in constrained modes. On desktop, play only
  // the most visible card so a grid never downloads/decodes several videos.
  const gridVideos = Array.from(document.querySelectorAll('.custom-jwd-grid__video video'));
  const visibility = new Map();
  const mobileViewport = window.matchMedia('(max-width: 640px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;

  function constrainedPlayback() {
    return mobileViewport.matches || reducedMotion.matches || Boolean(connection && connection.saveData);
  }

  function syncGridVideos() {
    let target = null;
    let targetRatio = 0;

    if (!document.hidden && !constrainedPlayback()) {
      visibility.forEach((ratio, video) => {
        if (ratio >= 0.5 && ratio > targetRatio) {
          target = video;
          targetRatio = ratio;
        }
      });
    }

    gridVideos.forEach(video => {
      if (video !== target) {
        video.pause();
        return;
      }
      if (video.paused) {
        if (window.MarlotVideoPlaybackCoordinator) {
          window.MarlotVideoPlaybackCoordinator.requestPlay(video);
        }
      }
    });
  }

  gridVideos.forEach(video => {
    video.autoplay = false;
    video.removeAttribute('autoplay');
    video.preload = 'none';
    video.setAttribute('preload', 'none');
    video.setAttribute('playsinline', '');
    video.setAttribute('muted', '');
    video.setAttribute('loop', '');
    if (window.MarlotVideoPlaybackCoordinator) {
      window.MarlotVideoPlaybackCoordinator.register(video);
    }
  });

  if ('IntersectionObserver' in window) {
    const videoObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        visibility.set(entry.target, entry.isIntersecting ? entry.intersectionRatio : 0);
      });
      syncGridVideos();
    }, {
      rootMargin: '0px',
      threshold: [0, 0.5, 0.75, 1]
    });

    gridVideos.forEach(video => videoObserver.observe(video));
  }

  document.addEventListener('visibilitychange', syncGridVideos);
  [mobileViewport, reducedMotion].forEach(mediaQuery => {
    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', syncGridVideos);
    } else if (typeof mediaQuery.addListener === 'function') {
      mediaQuery.addListener(syncGridVideos);
    }
  });
  if (connection && typeof connection.addEventListener === 'function') {
    connection.addEventListener('change', syncGridVideos);
  }

  // Stagger animation for cards based on scroll position
  const gridItems = document.querySelectorAll('.custom-jwd-grid__item');
  
  if (gridItems.length > 0) {
    const itemObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.animationPlayState = 'running';
          itemObserver.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '0px 0px -50px 0px',
      threshold: 0.1
    });

    gridItems.forEach(item => {
      item.style.animationPlayState = 'paused';
      itemObserver.observe(item);
    });
  }
});
